module.exports = __webpack_public_path__ + "static/media/cookie4.fd951cb9.png";